import $store from '@/store'

export default {

	list(type) {
 		var ret = _.filter($store.state.settings, (val, id) => {
    	return val.type == type;
    });
    return ret;
	},

	get_by_id(id) {
		return _.find($store.state.settings, (val, settings_id) => { return settings_id == id; });
	},

	get_by_name(name) {
		return _.find($store.state.settings, (val, id) => { return val.name == name; });
	},

	types() {
		return [
			{value: "headend_preview", label: "Headend Preview"},
			{value: "transcoder_configuration", label: "Transcoder configuration"},
			{value: "file_upload", label: "File upload"},
			{value: "post_process_configuration", label: "Post process configuration"},
			{value: "event_form", label: "Event form"},
			{value: "export_configuration", label: "Export configuration"},
			{value: "tag_form", label: "Tag form"},
			{value: "resource_form", label: "Resource form"},
			{value: "export_form", label: "Export form"},
			{value: "system", label: "System settings"},
			{value: "external_notifier", label: "External notifier"},
			{value: "signal_select", label: "Signal select"},
			{value: "device_type", label: "Device type"},
			{value: "billing_config", label: "Billing config"},
			{value: "developer_config", label: "Developer config"}
		];
	}

}
